import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShowComponent } from './show/show.component';
import { ShowsPageComponent } from './shows-page/shows-page.component';
import { AllMediaComponent } from './all-media/all-media.component';

const routes: Routes = [
    { path: 'all', component: AllMediaComponent },
    { path: 'all/:section', component: AllMediaComponent },
    { path: ':id', component: ShowComponent, data: { reuse: true } },
    { path: ':id/:section', component: ShowComponent, data: { reuse: true } },
    { path: ':id/:section/:productionID/:itemID', redirectTo: ':id/:productionID', data: { reuse: true } },
    { path: '', component: ShowsPageComponent },
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);